import { Controller } from "@hotwired/stimulus"
import { ImageUploadHelper } from "../src/image_upload_helper"

export default class extends Controller {
    static targets = ["imageUploadInput", "imageUploadButton"]
    static values = {
        directUploadUrl: { type: String, default: "/rails/active_storage/direct_uploads" }
    }

    triggerImageUpload() {
        this.imageUploadInputTarget.click();
    }

    handleImageSelected(event) {
        const file = event.target.files[0];
        if (file) {
            if (this.hasImageUploadButtonTarget) {
                const loadingButtonController = this.application.getControllerForElementAndIdentifier(this.imageUploadButtonTarget, "loading-button");
                if (loadingButtonController) {
                    loadingButtonController.showLoading();
                }
            }
            this.processAndSubmitImage(file);
        } else {
            // User cancelled file selection
            if (this.hasImageUploadButtonTarget) {
                this.imageUploadButtonTarget.dispatchEvent(new CustomEvent("loading-button:stop"));
            }
        }
        // Reset file input to allow selecting the same file again
        event.target.value = null;
    }

    processAndSubmitImage(file) {
        ImageUploadHelper.compressImage(file, (error, compressedBlob, originalFileName) => {
            if (error) {
                console.error("Image compression failed:", error);
                if (this.hasImageUploadButtonTarget) {
                    this.imageUploadButtonTarget.dispatchEvent(new CustomEvent("loading-button:stop"));
                }
                return;
            }

            ImageUploadHelper.uploadImage(compressedBlob, originalFileName, this.directUploadUrlValue, (uploadError, signedId) => {
                if (uploadError) {
                    console.error("Image upload failed:", uploadError);
                    if (this.hasImageUploadButtonTarget) {
                        this.imageUploadButtonTarget.dispatchEvent(new CustomEvent("loading-button:stop"));
                    }
                    return;
                }

                this.submitAnalysisForm(signedId);
            });
        });
    }

    submitAnalysisForm(signedId) {
        const form = document.getElementById('analyze-image-form');
        if (!form) {
            console.error("Could not find analyze-image-form");
            if (this.hasImageUploadButtonTarget) {
                this.imageUploadButtonTarget.dispatchEvent(new CustomEvent("loading-button:stop"));
            }
            return;
        }

        // Create a hidden input for the signed_id if it doesn't exist
        let imageInput = form.querySelector('input[name="analysis[image]"]');
        if (!imageInput) {
            imageInput = document.createElement('input');
            imageInput.type = 'hidden';
            imageInput.name = 'analysis[image]';
            form.appendChild(imageInput);
        }
        imageInput.value = signedId;

        // Submit the form
        form.submit();
        // Loading state will be handled by page navigation
    }


}
